export const traditional = [
  {
    number: 'TBB100',
    hasModel: false,
  },
  {
    number: 'TBB101',
    hasModel: false,
  },
  {
    number: 'TBB102',
    hasModel: false,
  },
  {
    number: 'TBB103',
    hasModel: false,
  },
  {
    number: 'TBB104',
    hasModel: false,
  },
  {
    number: 'TBB105',
    hasModel: false,
  },
  {
    number: 'TBB106',
    hasModel: false,
  },
  {
    number: 'TBB107',
    hasModel: false,
  },
  {
    number: 'TBB108',
    hasModel: false,
  },
  {
    number: 'TBB109',
    hasModel: false,
  },
  {
    number: 'TBB110',
    hasModel: false,
  },
  {
    number: 'TBB111',
    hasModel: false,
  },
  {
    number: 'TBB112',
    hasModel: false,
  }
];
